function EditHOC({
  children,
  isPastMeeting
}) {
  if (isPastMeeting) return null;
  return children;
}
export default EditHOC;